import { TokenStatus as TokenStatusEnum } from '../../types';
import { CheckCircle, XCircle, AlertTriangle, Ban } from 'lucide-react';

interface TokenStatusProps {
  status: TokenStatusEnum;
  expiresInSeconds: number;
  providerIsActive?: boolean;
  providerTemplateIsActive?: boolean;
}

export const TokenStatus = ({
  status,
  expiresInSeconds,
  providerIsActive,
  providerTemplateIsActive,
}: TokenStatusProps) => {
  const getStatusConfig = () => {
    if (providerTemplateIsActive === false) {
      return {
        icon: AlertTriangle,
        label: 'Template inactive',
        className: 'bg-orange-100 text-orange-800 border-orange-300',
      };
    }

    if (providerIsActive === false) {
      return {
        icon: Ban,
        label: 'Provider inactive',
        className: 'bg-gray-100 text-gray-800 border-gray-300',
      };
    }

    switch (status) {
      case TokenStatusEnum.Active:
        if (expiresInSeconds < 300) {
          // Less than 5 minutes
          return {
            icon: AlertTriangle,
            label: 'Expires Soon',
            className: 'bg-yellow-100 text-yellow-800 border-yellow-300',
          };
        }
        return {
          icon: CheckCircle,
          label: 'Active',
          className: 'bg-green-100 text-green-800 border-green-300',
        };
      case TokenStatusEnum.RefreshFailed:
        return {
          icon: XCircle,
          label: 'Refresh Failed',
          className: 'bg-red-100 text-red-800 border-red-300',
        };
      case TokenStatusEnum.RequiresReauth:
        return {
          icon: AlertTriangle,
          label: 'Reauth Required',
          className: 'bg-orange-100 text-orange-800 border-orange-300',
        };
      case TokenStatusEnum.Revoked:
        return {
          icon: Ban,
          label: 'Revoked',
          className: 'bg-gray-100 text-gray-800 border-gray-300',
        };
      default:
        return {
          icon: AlertTriangle,
          label: 'Unknown',
          className: 'bg-gray-100 text-gray-800 border-gray-300',
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex max-w-full items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${config.className}`}
    >
      <Icon className="w-3 h-3 mr-1 shrink-0" />
      <span className="break-words leading-tight">{config.label}</span>
    </span>
  );
};
